import { type TableHeaderRow } from '@shared/table-generator';

export function questionUsageByQSetReportTableHeader(
  availableQSetCodeNumbers: number[],
  qSetName: string,
): TableHeaderRow[] {
  return [
    {
      children: [
        {
          id: 'no',
          children: 'No.',
          align: 'center',
          rowSpan: 2,
          width: 64,
        },
        {
          id: 'questionId',
          children: 'QID',
          align: 'center',
          rowSpan: 2,
          width: 200,
        },
        {
          id: 'type',
          children: 'Type',
          align: 'left',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'pInitial',
          children: 'P Initial',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'pUsed',
          children: 'P Used',
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        {
          id: 'bIndexInitial',
          children: `B-Index\n(Initial)`,
          align: 'center',
          rowSpan: 2,
          width: 100,
        },
        ...(availableQSetCodeNumbers.length === 0
          ? []
          : [
              {
                id: 'qSetGroup',
                children: `ชุดข้อสอบ (${qSetName})`,
                align: 'center' as const,
                colSpan: availableQSetCodeNumbers.length,
                rowSpan: 1,
              },
            ]),
      ],
    },
    {
      children:
        availableQSetCodeNumbers.length === 0
          ? []
          : availableQSetCodeNumbers.map((qSetCodeNumber) => ({
              id: `qSet${qSetCodeNumber}`,
              children: `${qSetCodeNumber}`,
              align: 'center' as const,
              width: 80,
              rowSpan: 1,
            })),
    },
  ];
}
